module.exports = __webpack_public_path__ + "static/media/shopify_app_store.ac70e792.png";